
import React, {  useEffect } from 'react';
import ReactGA from 'react-ga4';
import Microlink from '@microlink/react';

const NewsGrid = ({filteredNews,isDarkMode,PagePreview,Calendar,ExternalLink,Share2,Eye,FeaturedPagePreview}) => {

    // Cargar datos al iniciar y cuando cambien los filtros
    useEffect(() => {
    }, []);

    return (<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredNews.map(item => (
            <div
                key={item.id}
                className={`rounded-lg overflow-hidden shadow-md transition-transform duration-300 hover:shadow-lg hover:-translate-y-1 ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`}
            >
                {false && <div className="h-48 overflow-hidden">
                    <PagePreview />
                </div>}
                <div className="p-4">
                    <div className="flex items-center text-sm mb-2">
                        <span className="mr-2 px-2 py-1 rounded-full bg-blue-100 text-blue-800 text-xs font-semibold">
                            {item.category}
                        </span>
                        <div className="flex items-center text-gray-500">
                            <Calendar className="w-4 h-4 mr-1" />
                            <span>{item.date}</span>
                        </div>
                    </div>
                    <h3 className="text-lg font-semibold mb-2">{item.title}</h3>

                    <p className={`text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-600'} mb-4`}>{item.resume}</p>
                    <div className="flex items-center justify-between">
                        <a
                            href={item.link_to_source}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center text-blue-500 hover:text-blue-700 text-sm"
                        >
                            Leer más <ExternalLink className="w-4 h-4 ml-1" onClick={() => {
                                ReactGA.event({
                                    category: 'Usuario',
                                    action: 'Click en noticia',
                                    label: item.category
                                });
                            }} />
                        </a>
                        <div className="flex space-x-3 text-xs">
                            <div className="flex items-center">
                                <Eye className="w-3 h-3 mr-1 text-gray-500" />
                                <span className="text-gray-500">{item.views}</span>
                            </div>
                            <div className="flex items-center">
                                <Share2 className="w-3 h-3 mr-1 text-gray-500" />
                                <span className="text-gray-500">{item.shares}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        ))}
    </div>
    )

}
export default NewsGrid;